module.exports = __webpack_public_path__ + "media/images/niq-save-c451ac8ce89672184937be4172b887e0.svg";